import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { ModeleHoraire } from './modele-horaire.entity';
import { Activite } from './activite.entity';

@Entity('modele_horaire_activite')
export class ModeleHoraireActivite {
    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: true })
    ordreAffichage: number;

    @Column({ nullable: true })
    fk_id_modele_horaire: number;

    @ManyToOne(() => ModeleHoraire)
    @JoinColumn({ name: 'fk_id_modele_horaire', referencedColumnName: 'id' })
    modeleHoraire: ModeleHoraire;

    @Column()
    fk_id_activite: number;

    @ManyToOne(() => Activite)
    @JoinColumn({ name: 'fk_id_activite', referencedColumnName: 'id' })
    activite: Activite;
}
